// extracted by mini-css-extract-plugin
export default {"header":"styles_header__pQmv0","title":"styles_title__4RhVG","rateWrap":"styles_rateWrap__3O1JD"};